import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "/",
     meta: { title: '法医毒物' },
    component: () => import("@/view/loaDing.vue"),
  },
    {
      path: '/index',
      name: 'index',
       meta: { title: '法医毒物' },
      component: () => import('@/view/index.vue')
    },
    {
      path: '/home',
      name: 'home',
       meta: { title: '法医毒物' },
      component: () => import('@/view/home.vue')
    }
];
const router = new VueRouter({
  routes,
});
export default router;
